module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "my-4 display-1"
  }, [_vm._v("Zaboravljena lozinka")]), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestResetPassword($event)
      }
    }
  }, [_c('v-text-field', {
    ref: "email",
    attrs: {
      "label": "email",
      "required": "",
      "autocomplete": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "large": "",
      "block": "",
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "large": "",
      "block": "",
      "to": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" "), (_vm.info) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "info"
    },
    domProps: {
      "textContent": _vm._s(_vm.info)
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}